import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Pessoa, ListaEnumTipoFornecedor } from 'src/app/classes/Pessoa';
import { PessoaService } from 'src/app/services/pessoa.service';
import { StorageService } from 'src/app/services/storage.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { Location } from '@angular/common';
import Swal from 'sweetalert2';
import { ColumnModel, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { SyncGridComponent } from '../../shared-farm/sync-grid/sync-grid.component';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment';
import { FormsFornecedorComponent } from './forms-fornecedor/forms-fornecedor.component';
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component';

@Component({
  selector: 'app-fornecedor',
  templateUrl: './fornecedor.component.html',
  styleUrls: ['./fornecedor.component.scss'],
})
export class FornecedorComponent implements OnInit {

  @ViewChild("gridFornecedores", { static: false })
  gridFornecedores: SyncGridComponent;

  @ViewChild("FormsFornecedor", { static: false })
  formsFornecedor: FormsFornecedorComponent;

  @ViewChild("ModalLink", { static: false })
  modalLink: UiModalComponent;

  fornecedores: Pessoa[] = [];
  auxFornecedores: Pessoa[];
  fornecedor: Pessoa;
  id: number;
  inserindo: boolean = false;
  carregando: boolean = false;
  isSuper: boolean = false;
  linkCadastroSenha: string = '';


  form: any;
  public isSubmit: boolean;
  textoBusca: string = "";
  perfilLogado: number = 0;

  fornecedorColumns: ColumnModel[] = [];
  desabilitarAcoes: boolean = false
  removendo: boolean = false
  inativando: boolean = false
  ativando: boolean = false
  duplicando: boolean = false
  gridHeight: string = '79vh';

  pageSettings?: PageSettingsModel = {
    pageSizes: [10, 20, 30, 40, 50, 100],
    pageSize: 20,
    pageCount: 4,
  };

  FEITO: string = "Feito!";
  ERRO: string = "Erro!";
  CANCELAR: string = "Cancelar";
  SIM: string = "Sim";
  CONFIRMAR_DELETE: string = "Se deletar, esta ação não poderá ser desfeita!";
  FORNECEDOR_DELETADO: string = "Fornecedor deletado!";
  FORNECEDOR_CADASTRADO: string = "Fornecedor cadastrado!";
  FORNECEDOR_ALTERADO: string = "Fornecedor alterado!";

  constructor(
    private pessoaService: PessoaService,
    private utils: UtilsService,
    private route: ActivatedRoute,
    private router: Router,
    private storageService: StorageService,
    private translate: TranslateService,
    private location: Location
  ) {
  }

  ngOnInit() {
    var usuarioLogado = this.storageService.getUsuario();
    this.isSuper = usuarioLogado.isSuper;
    this.perfilLogado = usuarioLogado.Perfil;
    this.fornecedor = new Pessoa();

    this.listarFornecedores();
    this.configurarGrid();
  }

  ajustarTamanhoGrid(): void {
    setTimeout(() => {
      const navbar = document.querySelector('app-nav-bar.navbar.pcoded-header') as HTMLElement
      const groupdroparea = document.querySelector('div.e-groupdroparea.e-lib.e-droppable.e-draggable') as HTMLElement
      const toolbar = document.querySelector('div.custom-toolbar.justify-content-between') as HTMLElement
      const title = document.querySelector('app-fornecedor h5.titulo') as HTMLElement
      const pager = document.querySelector('div.e-gridpager.e-control.e-pager.e-lib') as HTMLElement

      if (!navbar || !toolbar || !title || !pager) {
        return;
      }

      const groupdropareaHeight = groupdroparea ? groupdroparea.offsetHeight : 0;

      const altura = window.innerHeight - navbar.offsetHeight - groupdropareaHeight - toolbar.offsetHeight - title.offsetHeight - pager.offsetHeight - 70
      this.gridHeight = `${altura}px`
    }, 100);
  }

  configurarGrid(): void {
    if (window.innerHeight <= 1000) this.pageSettings.pageSize = 20;
    else this.pageSettings.pageSize = 40

    this.fornecedorColumns = [
      { type: "checkbox", width: 50, showInColumnChooser: false },
      {
        field: "NomeFantasia",
        type: "string",
        headerText: "Nome Fantasia",
        allowSorting: true,
      },
      {
        field: "RazaoSocial",
        type: "string",
        headerText: "Razão Social",
        allowSorting: true,
      },
      {
        field: "CpfCnpj",
        type: "string",
        headerText: "CNPJ",
        allowSorting: true,
      },
      {
        field: "inscricaoEstadual",
        type: "string",
        headerText: "IE",
        allowSorting: true,
      },
      {
        field: "TipoFornecedorNomes",
        headerText: "Tipo de Fornecedor",
        allowSorting: true,
        filter: {
          type: 'Excel'
        }
      },
      {
        field: "NomeResponsavel",
        type: "string",
        headerText: "Contato",
        allowSorting: true,
      },
      {
        field: "Telefone",
        type: "string",
        headerText: "Telefone",
        allowSorting: true,
      },
      {
        field: "Email",
        type: "string",
        headerText: "E-mail",
        allowSorting: true,
      },
      {
        field: "DataAlteracao",
        headerText: "Ult. Mod.",
        type: "date",
        format: "dd/MM/yyyy HH:mm",
        allowSorting: true,
        valueAccessor: (_field: string, _data: any): any => {
          if (_data.DataAlteracao) {
            const date = _data.DataAlteracao instanceof Date
              ? _data.DataAlteracao
              : new Date(_data.DataAlteracao);
            return isNaN(date.getTime()) ? null : date;
          }
          return null;
        }
      },
      {
        field: "UsuarioAlteracaoDesc",
        headerText: "Resp. Mod.",
        type: "string",
        allowSorting: true,
      },
      {
        field: "descStatus",
        headerText: "Status",
        allowSorting: true,
        disableHtmlEncode: false,
        type: 'boolean',
        valueAccessor: (_field: string, _data: any): any => {
          return this.badgeStatusUsuario(_data.descStatus);
        }
      } as ColumnModel,
    ]
    this.ajustarTamanhoGrid();
  }

  doubleClick(event): void {
    this.editar(event)
  }

  badgeStatusUsuario(status: string): string {
    if(status == 'Pendente'){
      return '<span class="badge badge-light-warning custom-badge-grid">Pendente</span>'
    } else if(status == 'Ativo'){
      return '<span class="badge badge-light-success custom-badge-grid">Ativo</span>'
    } else {
      return '<span class="badge badge-light-danger custom-badge-grid">Inativo</span>'
    }
  }

  selecionarFornecedor() {
    this.ERRO = this.translate.instant("ERRO");

    this.carregando = true;
    this.pessoaService.get(this.id).subscribe(res => {
      this.fornecedor = new Pessoa();
      this.fornecedor = res;
      this.carregando = false;
    },
      err => {
        this.utils.getErro(err);
        this.carregando = false;
      })
  }

  listarFornecedores() {
    this.ERRO = this.translate.instant("ERRO");
    this.carregando = true;
    this.pessoaService.listarFornecedores()
      .pipe(
        finalize(() => {
          this.carregando = false;
        })
      )
      .subscribe(
        (res: Pessoa[]) => {
          this.fornecedores = res.map(u => {
            const pessoa = Object.assign(new Pessoa(), u);
            // Criar campo auxiliar com os nomes dos tipos para o filtro Excel
            if (pessoa.ListaTipoFornecedor && pessoa.ListaTipoFornecedor.length > 0) {
              const nomes = pessoa.ListaTipoFornecedor
                .map((tipo: number) => {
                  const itemTipo = ListaEnumTipoFornecedor.find(item => item.value === tipo);
                  return itemTipo ? itemTipo.name : '';
                })
                .filter((nome: string) => nome !== '');
              (pessoa as any).TipoFornecedorNomes = nomes.join(', ');
            } else {
              (pessoa as any).TipoFornecedorNomes = '';
            }
            return pessoa;
          });
          if (!this.inserindo)
            this.auxFornecedores = res;
          if (this.textoBusca != '')
            this.filtrarFornecedores();
        },
        err => {
          this.utils.getErro(err);
        })
  }



  novo(): void {
    // TODO: Implementar quando necessário
    // if (!this.utils.verificarPermissaoUsuario('IncluirFornecedor'))
    //   return;
    this.formsFornecedor.abrirModal();
  }

  editar(fornecedor: Pessoa): void {
    let forn;
    if (!fornecedor) {
      var fornecedores = this.gridFornecedores.getSelectedRecords();
      if (!this.ValidarSelectApenasUm()) return;
      forn = { ...fornecedores[0] };
    }
    else
      forn = { ...fornecedor }
    this.formsFornecedor.abrirModal(forn);
  }

  ValidarSelectApenasUm(): boolean {
    var fornecedores = this.gridFornecedores.getSelectedRecords();
    if (fornecedores.length == 0) {
      this.utils.handleWarning("Selecione um item para continuar");
      return false;
    }
    if (fornecedores.length > 1) {
      this.utils.handleWarning("Selecione apenas um item para continuar");
      return false;
    }
    return true;
  }

  ValidarSelectUmOuMais(): boolean {
    var fornecedores = this.gridFornecedores.getSelectedRecords();
    if (fornecedores.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return false;
    }

    return true;
  }

  confirmaDuplicar(): void {
    var fornecedores = this.gridFornecedores.getSelectedRecords();
    if (!this.ValidarSelectUmOuMais()) return
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os fornecedores selecionados serão duplicados!",
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Duplicar fornecedores",
    }).then((response) => {
      if (!response.dismiss) {
        this.duplicar(fornecedores);
      }
    });
  }

  duplicar(fornecedores: Pessoa[]): void {
    // TODO: Implementar quando necessário
    this.utils.handleWarning("Funcionalidade em desenvolvimento");
  }

  confirmaInativar(): void {
    if (!this.ValidarSelectUmOuMais()) return
    var fornecedores = this.gridFornecedores.getSelectedRecords();
    if (fornecedores.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }

    // Separar fornecedores pendentes dos não pendentes
    const fornecedoresPendentes = fornecedores.filter(f => f.descStatus === 'Pendente');
    const fornecedoresNaoPendentes = fornecedores.filter(f => f.descStatus !== 'Pendente');

    // Se todos são pendentes, bloquear a ação
    if (fornecedoresNaoPendentes.length === 0) {
      const nomesPendentes = fornecedoresPendentes.map(f => f.NomeFantasia || f.RazaoSocial).join(', ');
      Swal.fire({
        title: "Ação não permitida",
        html: `Não é possível inativar fornecedores com status "Pendente".<br><br><b>Fornecedores pendentes:</b><br>${nomesPendentes}`,
        type: "warning",
        showCloseButton: true,
        confirmButtonText: "OK"
      });
      return;
    }

    // Se há pendentes e não pendentes, informar e continuar apenas com os não pendentes
    if (fornecedoresPendentes.length > 0) {
      const nomesPendentes = fornecedoresPendentes.map(f => f.NomeFantasia || f.RazaoSocial).join(', ');
      Swal.fire({
        title: "Atenção",
        html: `Alguns fornecedores selecionados estão com status "Pendente" e serão ignorados.<br><br><b>Fornecedores pendentes (serão ignorados):</b><br>${nomesPendentes}`,
        type: "info",
        showCloseButton: true,
        confirmButtonText: "Continuar"
      }).then(() => {
        this.processarInativar(fornecedoresNaoPendentes);
      });
    } else {
      // Nenhum pendente, processar normalmente
      this.processarInativar(fornecedoresNaoPendentes);
    }
  }

  processarInativar(fornecedores: Pessoa[]): void {
    const todosInativos = fornecedores.every(f => f.Ativo === false);
    const algumInativo = fornecedores.some(f => f.Ativo === false);

    if (todosInativos) {
      this.utils.handleWarning("Todos os fornecedores selecionados já estão inativos");
      return;
    }

    let texto = "Os fornecedores selecionados serão inativados!";
    if (algumInativo) {
      texto += '<br> Alguns fornecedores já estão inativos e serão ignorados.';
    }

    Swal.fire({
      title: "Você tem certeza desta ação?",
      html: texto,
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Inativar fornecedores",
    }).then((response) => {
      if (!response.dismiss) {
        this.inativar(fornecedores);
      }
    });
  }
  confirmarAtivar(): void{
    if (!this.ValidarSelectUmOuMais()) return
    var fornecedores = this.gridFornecedores.getSelectedRecords();
    if (fornecedores.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }

    // Separar fornecedores pendentes dos não pendentes
    const fornecedoresPendentes = fornecedores.filter(f => f.descStatus === 'Pendente');
    const fornecedoresNaoPendentes = fornecedores.filter(f => f.descStatus !== 'Pendente');

    // Se todos são pendentes, bloquear a ação
    if (fornecedoresNaoPendentes.length === 0) {
      const nomesPendentes = fornecedoresPendentes.map(f => f.NomeFantasia || f.RazaoSocial).join(', ');
      Swal.fire({
        title: "Ação não permitida",
        html: `Não é possível ativar fornecedores com status "Pendente".<br><br><b>Fornecedores pendentes:</b><br>${nomesPendentes}`,
        type: "warning",
        showCloseButton: true,
        confirmButtonText: "OK"
      });
      return;
    }

    // Se há pendentes e não pendentes, informar e continuar apenas com os não pendentes
    if (fornecedoresPendentes.length > 0) {
      const nomesPendentes = fornecedoresPendentes.map(f => f.NomeFantasia || f.RazaoSocial).join(', ');
      Swal.fire({
        title: "Atenção",
        html: `Alguns fornecedores selecionados estão com status "Pendente" e serão ignorados.<br><br><b>Fornecedores pendentes (serão ignorados):</b><br>${nomesPendentes}`,
        type: "info",
        showCloseButton: true,
        confirmButtonText: "Continuar"
      }).then(() => {
        this.processarAtivar(fornecedoresNaoPendentes);
      });
    } else {
      // Nenhum pendente, processar normalmente
      this.processarAtivar(fornecedoresNaoPendentes);
    }
  }

  processarAtivar(fornecedores: Pessoa[]): void {
    const todosAtivos = fornecedores.every(f => f.Ativo === true);
    const algumAtivo = fornecedores.some(f => f.Ativo === true);

    if (todosAtivos) {
      this.utils.handleWarning("Todos os fornecedores selecionados já estão ativos");
      return;
    }

    let texto = "Os fornecedores selecionados serão ativados!";
    if (algumAtivo) {
      texto += '<br> Alguns fornecedores já estão ativos e serão ignorados.';
    }

    Swal.fire({
      title: "Você tem certeza desta ação?",
      html: texto,
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Ativar fornecedores",
    }).then((response) => {
      if (!response.dismiss) {
        this.ativar(fornecedores);
      }
    });
  }

  ativar(fornecedores: Pessoa[]): void {
    this.ativando = true;
    this.pessoaService.ativarFornecedor(fornecedores.map(p => p.Id)).subscribe(
      res => {
        this.utils.handleSuccess("Fornecedores ativados com sucesso");
        this.listarFornecedores();
        this.ativando = false;
      },
      err => {
        this.utils.getErro(err);
        this.ativando = false;
      })
    }
  inativar(fornecedores: Pessoa[]): void {
    this.inativando = true;
    this.pessoaService.inativarFornecedor(fornecedores.map(p => p.Id)).subscribe(
      res => {
        this.utils.handleSuccess("Fornecedores inativados com sucesso");
        this.listarFornecedores();
        this.inativando = false;
      },
      err => {
        this.utils.getErro(err);
        this.inativando = false;
      });
  }

  finalizarSaveFornecedor(fornecedor?: Pessoa): void {
    this.listarFornecedores();
    // Se foi passado um fornecedor, significa que foi criado um novo fornecedor
    if (fornecedor && fornecedor.TokenAcesso) {
      this.gerarLink(fornecedor);
    }
  }

  gerarLinkFornecedor(): void {
    var fornecedores = this.gridFornecedores.getSelectedRecords();
    if (!this.ValidarSelectApenasUm()) return;
    const fornecedor = fornecedores[0];
    if (!fornecedor.TokenAcesso) {
      this.utils.handleWarning('Este fornecedor não possui token de acesso. É necessário que o fornecedor tenha um tokenAcesso cadastrado.');
      return;
    }
    this.gerarLink(fornecedor);
  }

  gerarLink(fornecedor: Pessoa): void {
    if (!fornecedor || !fornecedor.TokenAcesso) {
      this.utils.handleWarning('Fornecedor não possui token de acesso.');
      return;
    }
    const baseUrl = window.location.origin + window.location.pathname;
    this.linkCadastroSenha = `${baseUrl}#/fornecedor/cadastro-senha/${fornecedor.TokenAcesso}`;
    this.modalLink.show();
  }

  copiarLink(): void {
    const input = document.createElement('input');
    input.value = this.linkCadastroSenha;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    this.utils.handleSuccess('Link copiado para a área de transferência!');
  }

  fecharModalLink(): void {
    this.modalLink.hide();
    this.linkCadastroSenha = '';
  }

  confirmRemover() {
    this.ERRO = this.translate.instant("ERRO");
    this.FEITO = this.translate.instant("FEITO");
    this.CONFIRMAR_DELETE = this.translate.instant("CONFIRMAR_DELETE");
    this.CANCELAR = this.translate.instant("CANCELAR");
    this.SIM = this.translate.instant("SIM");
    this.FORNECEDOR_DELETADO = this.translate.instant("FORNECEDOR_DELETADO");

    var fornecedores = this.gridFornecedores.getSelectedRecords();
    if (fornecedores.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os Fornecedores selecionados serão excluídos, esta ação não poderá ser desfeita!",
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
      if (!willDelete.dismiss)
        this.removerFornecedores(fornecedores)
    });
  }

  removerFornecedores(fornecedores: Pessoa[]) {
    this.removendo = true;
    this.pessoaService.deleteFonecedores(fornecedores.map(p => p.Id)).subscribe(
      res => {
        console.debug('res: ', res)

        // Verificar se há erros no retorno (Dictionary<int, string>)
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          // Há erros - exibir quais fornecedores falharam
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const fornecedor = fornecedores.find(f => f.Id.toString() === id);
            const nomeFornecedor = fornecedor ? fornecedor.NomeFantasia || fornecedor.RazaoSocial : `ID ${id}`;
            erros.push(`<b>${nomeFornecedor}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao excluir fornecedores',
            html: `As seguintes fornecedores não puderam ser excluídos:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else {
          // Sucesso - todos os fornecedores foram excluídos
          this.utils.handleSuccess("Fornecedores excluídos com sucesso");
        }

        this.listarFornecedores();
        this.removendo = false;
      },
      err => {
        this.utils.getErro(err);
        this.removendo = false;
      });
  }

  filtrarFornecedores() {
    this.fornecedores = this.auxFornecedores.filter(x =>
      x.NomeFantasia.toUpperCase().includes(this.textoBusca.toUpperCase()) ||
      x.RazaoSocial.toUpperCase().includes(this.textoBusca.toUpperCase()) ||
      x.CpfCnpj.toString().includes(this.textoBusca.toUpperCase()) ||
      x.Id.toString().includes(this.textoBusca.toUpperCase())
    ).map(u => {
      const pessoa = Object.assign(new Pessoa(), u);
      // Criar campo auxiliar com os nomes dos tipos para o filtro Excel
      if (pessoa.ListaTipoFornecedor && pessoa.ListaTipoFornecedor.length > 0) {
        const nomes = pessoa.ListaTipoFornecedor
          .map((tipo: number) => {
            const itemTipo = ListaEnumTipoFornecedor.find(item => item.value === tipo);
            return itemTipo ? itemTipo.name : '';
          })
          .filter((nome: string) => nome !== '');
        (pessoa as any).TipoFornecedorNomes = nomes.join(', ');
      } else {
        (pessoa as any).TipoFornecedorNomes = '';
      }
      return pessoa;
    });
  }

  cancelar() {
    this.router.navigate(['/cadastros/fornecedor']);
  }
}
